import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Paper, Typography } from '@mui/material';
import { AccountTree as ConditionIcon } from '@mui/icons-material';
import { WorkflowNode } from '../../../../types/workflow.types';

const ConditionNode: React.FC<NodeProps<WorkflowNode['data']>> = ({ data, selected }) => {
  const config = data?.config || {};

  return (
    <Paper
      elevation={selected ? 8 : 2}
      style={{
        padding: 16,
        minWidth: 150,
        maxWidth: 250,
        backgroundColor: '#FFC107',
        color: '#1A1A1A',
        border: selected ? '3px solid #1976d2' : '1px solid #FFA000',
        borderRadius: 8,
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        position: 'relative',
      }}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          backgroundColor: '#FFA000',
          border: '2px solid white',
          width: 12,
          height: 12,
        }}
      />

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <ConditionIcon style={{ fontSize: 20 }} />
        <Typography variant="subtitle2" fontWeight="bold">
          {data?.title || 'Condition'}
        </Typography>
      </div>

      {data?.description && (
        <Typography variant="caption" style={{ opacity: 0.8, fontSize: '0.7rem', marginBottom: 8, display: 'block' }}>
          {data?.description}
        </Typography>
      )}

      {config?.condition && (
        <Typography
          variant="caption"
          style={{
            opacity: 0.9,
            fontSize: '0.65rem',
            fontFamily: 'monospace',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            padding: '2px 4px',
            borderRadius: '4px',
            display: 'block',
            marginBottom: 8,
            wordBreak: 'break-all'
          }}
        >
          {config?.condition && config.condition.length > 30 ? config.condition.substring(0, 30) + '...' : config?.condition}
        </Typography>
      )}

      {!config?.condition && (
        <Typography variant="caption" style={{ opacity: 0.7, fontSize: '0.65rem' }}>
          Click to configure condition
        </Typography>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8, fontSize: '0.6rem' }}>
        <Typography variant="caption" style={{ opacity: 0.7 }}>
          TRUE
        </Typography>
        <Typography variant="caption" style={{ opacity: 0.7 }}>
          FALSE
        </Typography>
      </div>

      {/* True output handle (top right) */}
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{
          backgroundColor: '#4CAF50',
          border: '2px solid white',
          width: 12,
          height: 12,
          top: '30%',
        }}
      />

      {/* False output handle (bottom right) */}
      <Handle
        type="source"
        position={Position.Right}
        id="false"
        style={{
          backgroundColor: '#F44336',
          border: '2px solid white',
          width: 12,
          height: 12,
          top: '70%',
        }}
      />
    </Paper>
  );
};

export default ConditionNode;
